<template>
    <div style="background:#fff">
        <div class="skeleton-list">
            <div class="skeleton-item" v-for="(item,index) in data" :key="index">
                <div style="width:32%;margin-right:3%">
                    <van-skeleton title  title-width="100%" />
                    <van-skeleton title  title-width="100%" />
                    <van-skeleton title  title-width="100%" />
                    <van-skeleton title  title-width="100%" />
                </div>
                <div style="width:65%">
                    <van-skeleton :row="1" row-width="100%" />
                    <van-skeleton :row="1" row-width="100%" />
                    <van-skeleton class="price" style="margin-top:1rem;" :row="1" row-width="3rem"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "./index.less"
export default {
    name:"skeleton",
    data(){
        return{
            data:[0,1,2,3,4,5]
        }
    }
}
</script>